import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from "@angular/core";
import { IonIcon } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-error-chart",
    templateUrl: "./error-chart.component.html",
    styleUrls: ["./error-chart.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonIcon, TranslatePipe]
})
export class ErrorChartComponent implements OnInit {
  ngOnInit() {}

  ngOnChanges() {}
}
